export const buildCartItem = (product, quantity = 1, order, selectedComposition = '', selectedIndex = 0) => {
  if (!product || !order) return null;

  const { language, country, currency } = order;
  const localized = product.languages[language] || {};

  const price_r = currency ? product.prices[currency]?.price_r : product.regions[country]?.price_r;
  const price_w = currency ? product.prices[currency]?.price_w : product.regions[country]?.price_w;
  const price_w_add = currency ? product.prices[currency]?.price_w_add : product.regions[country]?.price_w_add;

  const baseCodes = (product.nomenclatureCode || '').split(',').map(code => code.trim());
  let mappedCode = product.nomenclatureCode;
  if (selectedComposition) {
    const code = baseCodes[selectedIndex] || baseCodes[0]; // safe fallback
    const compClean = selectedComposition.replace(/\s+/g, '_');
    mappedCode = `${code}_${compClean}`;
  }
  return {
    _id: product._id,
    nomenclatureCode: mappedCode,
    nomenclatureCode1C: product.nomenclatureCode,
    title: localized.title +' '+selectedComposition,
    description: localized.description,
    composition: selectedComposition !== '' ? selectedComposition : localized.composition,
    pic: product.pic,
    price_r: price_r || 0,
    price_w: price_w || 0,
    price_w_add: price_w_add || 0,
    country: country,
    r_amount: product.r_amount,
    w_amount: product.w_amount,
    w_amount_add: product.w_amount_add,
    quantity
  };
};
